import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList
} from 'recharts';

// Colors for different risk levels
const colors = {
  low: '#05769D',       // Blue for Low
  moderate: '#0BA6B0',  // Teal for Moderate
  high: '#FED4AE',      // Yellow for High
  extreme: '#F07167'    // Red for Extreme
};

// Custom Label for bar values
const CustomLabel = ({ x, y, width, value }) => (
  <text
    x={x + width / 2} // Center the label inside the bar
    y={y + 25} // Adjust vertical positioning
    textAnchor="middle"
    fill="#000"
    fontSize={14}
  >
    {value}
  </text>
);

// Function to determine the top risk severity for each row
const getTopRiskKey = (dataRow) => {
  if (dataRow.extreme > 0) return "extreme";
  if (dataRow.high > 0) return "high";
  if (dataRow.moderate > 0) return "moderate";
  return "low"; // Default if all are zero
};

// Main Component
const RiskLevelByDepartment = ({ height, data }) => {
  // Process data to include top risk field
  const processedData = data?.map(row => ({

    ...row,
    topRisk: getTopRiskKey(row) // Determine the highest severity risk per row
  }));

  return (
    <ResponsiveContainer width="100%" height={height} className="p-2 pb-2">
      <BarChart
        layout="vertical"
        data={processedData}
        margin={{ top: 0, right: 0, bottom: 0, left: 25 }}
      >
        <YAxis dataKey="name" type="category" />
        <XAxis type="number" hide={true} />
        <Tooltip />

        {/* Bars with dynamic rounding applied only to the highest risk level */}
        {["low", "moderate", "high", "extreme"].map((key) => (
          <Bar
            key={key}
            dataKey={key}
            stackId="a"
            fill={colors[key]}
            radius={(barData) => 
              barData.topRisk === key ? [0, 7, 7, 0] : [0, 0, 0, 0]
            } // Corrected: Now applies radius properly per bar
          >
            <LabelList dataKey={key} content={CustomLabel} />
          </Bar>
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};




export default RiskLevelByDepartment